export default "__VITE_ASSET__DjaaU0$X__"